import { createAction } from './utils'

const reducer = 'NOTIFICATIONS'

const notifyUpdate = createAction(reducer, 'NOTIFY_UPDATE')

export { notifyUpdate }
